<template>
  <div class="global-user">
    <div class="global-user-content" v-if="user.isLogin">
      <div class="global-user-content-user">
        <div class="global-user-content-name">{{ user.user_info.name }}</div>
        <i class="global-user-content-icon"></i>
      </div>
      <a href="javascript:" class="global-user-content-logout" @click="handleLogout">退出</a>
    </div>

    <div class="global-user-login" v-else>
      <span class="global-user-login-btn" @click="handleLogin(true)">登录</span>
    </div>
  </div>
</template>

<script>
  import business from './index.js';
  import userCenterBusiness from '@_src/common/core/business/userCenter';
  import { mapState } from 'vuex';

  export default {
    name: 'global-user',
    mixins: [userCenterBusiness, business],
    computed: {
      ...mapState({
        user: 'user',
      }),
    },
    methods: {},

    components: {},

    mounted () {
      this.handleGetUserInfo();
    },
  };
</script>

<style lang="less" src="./index.less"></style>
